import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RpAlertsComponent } from './rp-alerts/rp-alerts.component';

const routes: Routes = [

  { path: 'alerts', component: RpAlertsComponent },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AlertsRoutingModule { }
